module.exports = __webpack_public_path__ + "img/6.ff12a8f9.jpg";